export default "__VITE_ASSET__CKvP3yRi__"